import { render, staticRenderFns } from "./AgencyNeedNotification.vue?vue&type=template&id=56384190"
import script from "./AgencyNeedNotification.vue?vue&type=script&lang=js"
export * from "./AgencyNeedNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports